import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useDeleteSearchFilterMutation } from "../../Queries/FilterQueries";
import { ISavedSearch, ITimeFilter } from "../../../App/Typings/SearchFilters";
import { useNotification } from "../../State/Hooks/notificationHooks";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import Modal from "../Modal/Modal";
import { useTimeFilter } from "./Hooks/useTimeFilterHook";

export function SavedFilters({
  setTimeFilter,
  setTagFilters,
  dialogOpen,
  handleDialogClose,
  savedSearchFilters,
  clientId,
}: {
  setTimeFilter: (time: ITimeFilter) => void;
  setTagFilters: (tags: string[]) => void;
  dialogOpen: boolean;
  handleDialogClose: () => void;
  savedSearchFilters: ISavedSearch[];
  clientId?: string;
}) {
  const deleteSearchFilterMutation = useDeleteSearchFilterMutation(clientId);
  const { displayError, displaySuccess } = useNotification();
  const { findOptionByValue } = useTimeFilter({} as ITimeFilter, () => undefined);
  const sortedSavedSearchFilters = savedSearchFilters.sort((a, b) => (a.name > b.name ? 1 : -1));

  const handleItemClick = (savedFilter: ISavedSearch) => {
    const titleFilters: string[] = [];
    const tagFilters: string[] = [];
    let timeFilter: ITimeFilter | undefined = undefined;

    const searchParams = new URLSearchParams(savedFilter.searchString);
    searchParams.forEach((value, key) => {
      if (key === "tags") {
        tagFilters.push(value);
      } else if (key === "titles") {
        titleFilters.push(value);
      } else {
        //there's only 1 time filter
        timeFilter = findOptionByValue(Number(value));
      }
    });

    if (tagFilters.length > 0) setTagFilters(tagFilters);
    if (timeFilter) setTimeFilter(timeFilter);

    displaySuccess(`Filter applied: ${savedFilter.name}`);
  };

  const handleDeleteFilter = async (savedFilter: ISavedSearch) => {
    deleteSearchFilterMutation.mutate(savedFilter.id, {
      onError: () => {
        displayError("Error deleting filter");
      },
      onSuccess: () => {
        displaySuccess("Filter deleted");
      },
    });
  };

  return (
    <Modal
      isOpen={dialogOpen}
      handleCloseModal={handleDialogClose}
      title="Load Saved Filters"
      dataTestId="load-saved-filters-modal"
      content={
        <>
          {sortedSavedSearchFilters && savedSearchFilters.length > 0 ? (
            <List sx={{ minWidth: 400 }}>
              {sortedSavedSearchFilters.map((filter: ISavedSearch) => (
                <ListItem
                  key={filter.id}
                  sx={{ borderBottom: "1px #ccc solid" }}
                  secondaryAction={
                    <IconButton
                      title="Delete filter"
                      color="error"
                      edge="end"
                      aria-label="delete"
                      onClick={() => handleDeleteFilter(filter)}
                      data-test={"savedfilter-delete-" + filter.id}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemButton
                    onClick={() => {
                      handleItemClick(filter);
                      handleDialogClose();
                    }}
                    title="Load filter"
                    data-test={"savedfilter-select-" + filter.id}
                  >
                    <ListItemIcon>
                      <FilterListIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography>
                          <span style={{ fontWeight: "bold" }}>{filter.name}</span>
                          {filter.isPersonalFilter ? " (Private)" : null}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          ) : (
            <Box sx={{ minWidth: 400 }}>
              <Typography>No saved filters to display.</Typography>
            </Box>
          )}
        </>
      }
      footerContent={<></>}
    />
  );
}
